// extracted by mini-css-extract-plugin
module.exports = {"label":"PieLabel__label___Ak2YI","bold":"PieLabel__bold___iRMSC"};